import type { ReactNode } from "react";
import { CrmRecordTabs, type CrmRecordTab } from "@/components/crm/CrmRecordTabs";

type CrmRecordDetailLayoutProps = {
  basePath: string;
  activeTab: CrmRecordTab;
  searchParams?: URLSearchParams;
  connectedRecords: ReactNode;
  children: ReactNode;
};

/** Connected Records rail on the left; tabs and tab body on the right (stacked on small screens). */
export function CrmRecordDetailLayout({
  basePath,
  activeTab,
  searchParams,
  connectedRecords,
  children,
}: CrmRecordDetailLayoutProps) {
  return (
    <div className="space-y-4">
      <CrmRecordTabs basePath={basePath} activeTab={activeTab} searchParams={searchParams} />
      <div className="grid gap-4 lg:grid-cols-[280px_minmax(0,1fr)] lg:items-start">
        <div className="min-w-0 lg:sticky lg:top-20 lg:self-start">{connectedRecords}</div>
        <div className="min-w-0 space-y-4">{children}</div>
      </div>
    </div>
  );
}
